// Libs
import { useRef, useCallback } from 'react';

// Hook that returns *(always the same)* function that will forward the call to the latest passed `callback`
export function useLatestFunction(callback: () => void) {
  const ref = useRef({});

  ref.current = callback;

  return useCallback(function(...args) {
    const callback = ref.current;

    if (typeof callback === 'function') {
      return callback(...args);
    }
  }, []);
}
